import useSWR from 'swr';

import { getNovageSkincareConfiguration } from '../api';
import { useConfiguration } from '../contexts';
import type { NovageSkincareConfiguration } from '../models';
import { useLogError } from './useLogError';

export const useGetNovageSkincareConfiguration = () => {
  const configuration = useConfiguration();
  const { data, error } = useSWR<NovageSkincareConfiguration, Error>(
    [configuration.currentLanguage, configuration.staticApiUrl, configuration.tenant],
    async (currentLanguage: string, staticApiUrl: string, tenant: string) =>
      getNovageSkincareConfiguration({ currentLanguage, staticApiUrl, tenant }),
  );
  useLogError(error);

  return data;
};
